import Vue from 'vue';
import App from './App.vue';
import router from './router/routes';
import './router/guard';
import './mixins';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/firebase';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
